import script from "./sortAudioList.vue?vue&type=script&lang=ts&setup=true"
export * from "./sortAudioList.vue?vue&type=script&lang=ts&setup=true"

import "./sortAudioList.vue?vue&type=style&index=0&id=dee389c0&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dee389c0"]])

export default __exports__